<template>
  <body class="open-positions-body">
    <div class="title">We currently have no open positions</div>
  </body>
</template>

<script>
export default {
  name: "OpenPositions",
};
</script>
<style scoped>
.open-positions-body {
  padding: 47px 0px;
  display: flex;
  justify-content: center;
}
.title {
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  color: #000000;
}
</style>
